export var Buffers;
(function (Buffers) {
    function arrayBuffer(buffer) {
        return buffer.buffer.slice(buffer.byteOffset, buffer.byteOffset + buffer.byteLength);
    }
    Buffers.arrayBuffer = arrayBuffer;
    function buffer(arrayBuffer) {
        return Buffer.from(arrayBuffer);
    }
    Buffers.buffer = buffer;
    function streamToBuffer(stream) {
        const chunks = [];
        return new Promise((resolve, reject) => {
            stream.on('data', (chunk) => chunks.push(Buffer.from(chunk)));
            stream.on('error', (err) => reject(err));
            stream.on('end', () => resolve(Buffer.concat(chunks)));
        });
    }
    Buffers.streamToBuffer = streamToBuffer;
})(Buffers || (Buffers = {}));
//# sourceMappingURL=buffers.js.map